import { render, staticRenderFns } from "./FileModal.vue?vue&type=template&id=74beae08&scoped=true"
import script from "./FileModal.vue?vue&type=script&setup=true&lang=js"
export * from "./FileModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FileModal.vue?vue&type=style&index=0&id=74beae08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74beae08",
  null
  
)

export default component.exports